import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Inventory from "@/pages/Inventory";
import CarDetail from "@/pages/CarDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Financing from "@/pages/Financing";
import Admin from "@/pages/Admin";
import WindowSticker from "@/pages/WindowSticker";
import BuyersGuide from "@/pages/BuyersGuide";
import Videos from "@/pages/Videos";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/inventory" element={<Inventory />} />
            <Route path="/inventory/:id" element={<CarDetail />} />
            <Route path="/financing" element={<Financing />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
          <Route path="/admin" element={<Admin />} />
          <Route path="/inventory/:id/sticker" element={<WindowSticker />} />
          <Route path="/inventory/:id/buyers-guide" element={<BuyersGuide />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
